if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Reset loading state when page is restored from bfcache (browser back from checkout)
        this.pageshowHandler = (event) => {
          if (event.persisted) {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
        };
        window.addEventListener('pageshow', this.pageshowHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.pageshowHandler);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // 必須のラインアイテムプロパティ入力（line-item-inputs snippet）を検証
        const lineItemInputs = window.LineItemInputs
          ? window.LineItemInputs.collect(this.dataset.productId)
          : { ok: true, properties: null };
        if (!lineItemInputs.ok) return;

        // 他の購入ボタン（フローティング等）が送信中なら何もしない
        if (window.CartCheckout && window.CartCheckout.busy) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const variantId = this.variantIdInput.value;
        const formId = this.form.getAttribute('id');
        const quantity =
          this.form.querySelector('[name="quantity"]')?.value ||
          document.querySelector(`[form="${formId}"][name="quantity"]`)?.value ||
          1;

        const qty = parseInt(quantity);
        const quantityInput = this.form.querySelector('[name="quantity"]') ||
          document.querySelector(`[form="${formId}"][name="quantity"]`);
        const isBulk = quantityInput?.dataset?.lastVariantBulk === 'true';
        const actualQuantity = (typeof window.shouldApplyBonus === 'function' && window.shouldApplyBonus(qty, isBulk)) ? qty + 1 : qty;

        try {
          if (!window.CartCheckout) {
            throw new Error('ページの読み込み中です。少し待ってからもう一度お試しください。');
          }

          // カートを空にして本商品だけを追加し、/cart.js で実際に入ったことを確認する
          // （空カートのまま /checkout へ進むと Shopify がサイト TOP へ飛ばすため）
          await window.CartCheckout.prepare({
            variantId,
            quantity: actualQuantity,
            properties: lineItemInputs.properties,
          });

          this.error = false;
          window.location.href = '/checkout';
        } catch (e) {
          console.error(e);
          this.handleErrorMessage(e.message);
          this.error = true;

          // 売り切れ等で add.js が拒否した場合のみ、ボタン表記を切り替える
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (e.addData && soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
        } finally {
          if (this.error) {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = text || window.variantStrings?.addToCart || '今すぐ購入';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
